module.exports = __webpack_public_path__ + "img/podium-background.59bfb648.png";